/** @format */

import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

export const CardSelect = props => {
    const {onChange, value, options} = props;

    const [currentValue, setCurrentValue] = useState(value || undefined);

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    const handleSelection = selectedValue => {
        setCurrentValue(selectedValue);
        onChange(selectedValue);
    };

    return (
        <div className="card-select-77aa">
            <div className="card-select-77aa__container">
                {options.map((option, index) => {
                    const {image, title, description} = option; // Destructure option for clarity

                    return (
                        <button
                            key={index}
                            className={`selection-card-10th d-flex align-items-start justify-content-start m-0 ${
                                currentValue === option.value ? 'selection-card--selected' : ''
                            }`}
                            onClick={() => handleSelection(option.value)} // Call handleSelection on click
                        >
                            {image && (
                                <div className="selection-card-10th__image d-flex align-items-center justify-content-center flex-shrink-0">
                                    <img src={image} alt={title} />
                                </div>
                            )}
                            <div className="selection-card-10th__content">
                                {typeof title === 'string' ? (
                                    <h3 className="selection-card-10th__title p-0">{title}</h3>
                                ) : (
                                    <>{title}</>
                                )}
                                {typeof description === 'string' ? (
                                    <p className="selection-card-10th__description m-0 p-0">
                                        {description}
                                    </p>
                                ) : (
                                    <>{description}</>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

CardSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
            description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
            image: PropTypes.string
        })
    ).isRequired
};
